import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
    selector: 'app-dialog-information-component',
    templateUrl: './dialog-information.component.html',
})
export class DialogInformationComponent {
    constructor(
        public dialogRef: MatDialogRef<DialogInformationComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) { }

    ngAfterViewInit() {
        const activeElement = document.activeElement as HTMLElement;
        if (activeElement) {
            activeElement.blur();
        }
    }

    onConfirmClick(): void {
        this.dialogRef.close(true)
    }
}
